import fetchAudioBuffer from './fetch-audio-buffer';
import methodPatch from './method-patch';
import reverseBuffer from './reverse-buffer';

const SoundUtils = {
  fetchAudioBuffer,
  methodPatch,
  reverseBuffer,
};

export default SoundUtils;
